var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeDurationSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0154 2.36928C17.0471 3.09377 17.926 4.01439 18.602 5.07856C19.2779 6.14273 19.7376 7.32961 19.9548 8.57145C20.1721 9.81328 20.1426 11.0857 19.8681 12.3162C19.5935 13.5466 19.0793 14.7109 18.3548 15.7426C17.6303 16.7744 16.7097 17.6533 15.6456 18.3292C14.5814 19.0051 13.3945 19.4648 12.1527 19.6821C10.9108 19.8993 9.63838 19.8698 8.40795 19.5953C7.17751 19.3208 6.01319 18.8066 4.98147 18.0821C3.94976 17.3576 3.07084 16.437 2.39491 15.3728C1.71898 14.3086 1.25927 13.1218 1.04204 11.8799C0.8248 10.6381 0.854286 9.36563 1.12881 8.13519C1.40334 6.90475 1.91753 5.74044 2.64203 4.70872C3.36653 3.677 4.28714 2.79809 5.35131 2.12216C6.41548 1.44623 7.60237 0.98652 8.8442 0.769282C10.086 0.552045 11.3585 0.581532 12.5889 0.856059C13.8194 1.13059 14.9837 1.64478 16.0154 2.36928L16.0154 2.36928Z",
    stroke: "#051B46",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.487 9.02568L10.2988 11.4257V4.82568",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeDurationSymbol);
export default __webpack_public_path__ + "static/media/time-duration-symbol.81f47f71516b5283ab42b2d24216bb4c.svg";
export { ForwardRef as ReactComponent };